import React from "react";
import { MDBRow } from 'mdb-react-ui-kit';

export default function Informazioni({
    setMessage,
}) {

    return (
        <MDBRow>
            <div className="field">
                <label className='customLab' for="message">Messaggio *</label>
                <textarea className="message-field" type="textarea" placeholder="Messaggio" name="message" id="message" onChange={e => setMessage(e.target.value)} />
            </div>
        </MDBRow>
    );
}